import SVGFactory from "./SVGFactory";

export default class SVGCircle {
  private element: SVGElement;
  private circumference: number;

  constructor() {
    const radius = 56;
    this.circumference = 2 * Math.PI * radius;
    this.element = SVGFactory.create("circle", {
      cx: 50,
      cy: 50,
      r: radius,
      fill: "transparent",
      stroke: "#d3b9f0",
      "stroke-width": 5,
      "stroke-linecap": "round",
      "stroke-dasharray": this.circumference,
      "stroke-dashoffset": this.circumference,
    });
  }

  get htmlElement(): SVGElement {
    return this.element;
  }

  stroke(value: number): void {
    this.element.setAttribute(
      "stroke-dashoffset", `${this.circumference * (1 - value)}`
    );
  }
}
